import Vue from 'vue'
import Vuex from 'vuex'
import simpleCrypto from '@/helpers/crypto'
import axios from '@/helpers/axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    transDefault: [],
    profile: {},
    appid: '',
    appkey: '',
    apidoc: '',
    accessApi: '',
    idClient: '',
    token: '',
    username: '',
    receiver: '',
    logo_cl: '',
    expired: '',
    mini: true,
    access_api: '',
    showRedemption: '',
    transactionTabs: [
      { index: 0, name: 'API and Manual', to: '/transaction' },
      { index: 1, name: 'Direct Customer Delivery', to: '/transaction-v2' }
    ],
    orderTabs: [
      { index: 0, name: 'API and Manual', to: '/order' },
      { index: 1, name: 'Direct Customer Delivery', to: '/order-v2' }
    ],
    dtcTabs: [
      { index: 0, name: 'Success', to: '/dtc-success' },
      { index: 1, name: 'Failed', to: '/dtc-failed' }
    ]
  },
  getters: {
    getAppId: (state) => {
      return state.appid
    },
    getAppKey: (state) => {
      return state.appkey
    },
    getApiDoc: (state) => {
      return state.apidoc
    },
    getMini: (state) => {
      return state.mini
    }
  },
  mutations: {
    setTransDefault (state, payload) {
      state.transDefault = payload
    },
    setProfile (state, payload) {
      state.profile = payload
    },
    setMini (state, payload) {
      state.mini = payload
    },
    initialiseStore (state) {
      if (localStorage.getItem('_pid')) {
        let appid = simpleCrypto.decrypt(localStorage.getItem('_pid'))
        state.appid = appid
      }
      if (localStorage.getItem('_pky')) {
        let appkey = simpleCrypto.decrypt(localStorage.getItem('_pky'))
        state.appkey = appkey
      }
      if (localStorage.getItem('_idc')) {
        let apidoc = simpleCrypto.decrypt(localStorage.getItem('_idc'))
        state.apidoc = apidoc
      }
      if (localStorage.getItem('as_api')) {
        let accessApi = simpleCrypto.decrypt(localStorage.getItem('as_api'))
        state.accessApi = accessApi
      }
      if (localStorage.getItem('_ict')) {
        let idClient = simpleCrypto.decrypt(localStorage.getItem('_ict'))
        state.idClient = idClient
      }
      if (localStorage.getItem('t_tk')) {
        state.token = localStorage.getItem('t_tk')
      }
      if (localStorage.getItem('u_nm')) {
        let username = simpleCrypto.decrypt(localStorage.getItem('u_nm'))
        state.username = username
      }
      if (localStorage.getItem('e_rcv')) {
        let receiver = simpleCrypto.decrypt(localStorage.getItem('e_rcv'))
        state.receiver = receiver
      }
      if (localStorage.getItem('lg_cl')) {
        let logo = simpleCrypto.decrypt(localStorage.getItem('lg_cl'))
        state.logo_cl = logo
      }
      if (localStorage.getItem('xrd')) {
        state.expired = localStorage.getItem('xrd')
      }
      if (localStorage.getItem('shw_rdmptn')) {
        let showRedemption = simpleCrypto.decrypt(localStorage.getItem('shw_rdmptn'))
        state.showRedemption = showRedemption
      }
    }
  },
  actions: {
    getTransDefault (context) {
      let start = new Date(Date.now() - 259200000).toISOString().substr(0, 10)
      let end = new Date().toISOString().substr(0, 10)

      axios.defaults.headers = {
        accessToken: context.state.token,
        milliseconds: context.state.expired
      }

      axios
        .post('/getHistory', {
          request_id: `Req-${new Date().getTime()}-hist`,
          start_date: start + ' 00:00:00',
          end_date: end + ' 23:59:59',
          current_page: '1',
          max_records: '300',
          sort: 'DESC'
        })
        .then((response) => {
          context.commit('setTransDefault', response.data.data)
        })
        .catch((error) => {
          console.warn(error.response.data.message)
        })
    },
    getTransDefaultv2 (context) {
      let start = new Date(Date.now() - 259200000).toISOString().substr(0, 10)
      let end = new Date().toISOString().substr(0, 10)

      axios.defaults.headers = {
        accessToken: context.state.token,
        milliseconds: context.state.expired
      }

      axios
        .post('/refOrderList', {
          request_id: `Req-${new Date().getTime()}-hist`,
          start_date: start + ' 00:00:00',
          end_date: end + ' 23:59:59',
          current_page: '1',
          max_records: '100',
          sort: 'DESC'
        })
        .then((response) => {
          context.commit('setTransDefault', response.data.data)
        })
        .catch((error) => {
          console.warn(error.response.data.message)
        })
    },
    refresh (context) {
      let appkey = context.state.appkey
      let appid = context.state.appid

      axios
        .get(`/accesstoken?app_id=${appid}&app_key=${appkey}`)
        .then((response) => {
          if (response.data.token) {
            localStorage.setItem('t_tk', response.data.token)
            localStorage.setItem(
              'xrd',
              new Date(response.data.expired_time).getTime()
            )
          }
          window.location.reload()
        })
        .catch((error) => {
          console.warn(error.response.data.message)
        })
    },
    clear () {
      // localStorage.clear()
      localStorage.removeItem('_pid')
      localStorage.removeItem('_pky')
      localStorage.removeItem('_idc')
      localStorage.removeItem('_ict')
      localStorage.removeItem('t_tk')
      localStorage.removeItem('u_nm')
      localStorage.removeItem('e_rcv')
      localStorage.removeItem('lg_cl')
      localStorage.removeItem('xrd')
      window.location.reload()
    }
  }
})
